// Values that tie the code to one study and its location. See README.md.
//
// Pure data: no imports, no functions, no process.env. Constants.js imports
// this file, so it ships in both browser bundles and must never hold a secret.
// Keys match the Python library's config/general_*.json.
const GENERAL_CONFIG = {
  timezone: 'Asia/Kolkata',
  languages: ['gu', 'hi', 'es'],
  api_url: 'https://api2.community-hats.net',
  api_url_front: 'https://edge.community-hats.net',
};

export default GENERAL_CONFIG;
